import React from 'react';
import { connect } from 'react-redux';
import CollectionPageComponent from './CollectionPage.component';
import { getLinkType } from '../../reducers/feature.reducer';
import { EXTERNAL_NAMESPACE } from '../../constants';

export const mapStateToProps = (state, ownProps) => {
  const { pathname } = ownProps.location;
  const querystring = ownProps.location.search;
  const linkType = getLinkType({ state: state.feature, page: 'collection', tag: 'product_pod' });
  const { familyId } = ownProps.match.params;

  return {
    familyId,
    linkType,
    namespace: EXTERNAL_NAMESPACE,
    pathname,
    querystring
  };
};

export const mapDispatchToProps = (_, ownProps) => {
  return {
    replace: ownProps.history.replace,
    push: ownProps.history.push
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPageComponent);
